export default {
  isPreparingApp(state: any): boolean {
    return state.loading || state.initializing
  },
  isInitializingApp(state: any): boolean {
    return state.initializing
  },
  isPreparingUsageData(state: any): boolean {
    return state.loadingUsage || state.initializing
  },
}
